// extracted by mini-css-extract-plugin
export var marginNegative = "_5y-5 _5y-3 _5y-1";
export var marginPositive = "_5y-4 _5y-3 _5y-1";
export var modalContent = "_5y-6";
export var samplesTable = "_5y-8";
export var samplesTableContainer = "_5y-7";
export var statBox = "_5y-a";
export var tableCell = "_5y-1";
export var tableCellCenter = "_5y-2 _5y-1";
export var tableCellRight = "_5y-3 _5y-1";
export var tableHeader = "_5y-0";
export var trackingNumber = "_5y-9";